import { API_BLOB } from '.'
import type { BlobResponse } from '.'

export function exportMediations(year?: number, month?: number): Promise<BlobResponse> {
  const params = new URLSearchParams()
  if (year) params.set('year', String(year))
  if (month) params.set('month', String(month))

  return API_BLOB(
    `/union/mediations/export?${params.toString()}`,
    { method: 'GET' },
    'Fehler beim Herunterladen der Vermittlungsdaten',
    'EXPORT_MEDIATIONS_ERROR'
  )
}

export function exportActivities(
  year: number,
  month: number,
  format: 'xlsx' | 'csv'
): Promise<BlobResponse> {
  const params = new URLSearchParams({
    year: String(year),
    month: String(month),
    format,
  })

  return API_BLOB(
    `/union/activities/export?${params.toString()}`,
    { method: 'GET' },
    'Fehler beim Herunterladen der Aktivitätsdaten',
    'EXPORT_ACTIVITIES_ERROR'
  )
}

export function exportActivitiesZip(year: number, month: number): Promise<BlobResponse> {
  const params = new URLSearchParams({
    year: String(year),
    month: String(month),
  })

  return API_BLOB(
    `/union/activities/export/zip?${params.toString()}`,
    { method: 'GET' },
    'Fehler beim Herunterladen der Aktivitäten mit PDFs',
    'EXPORT_ACTIVITIES_ZIP_ERROR'
  )
}

export function exportMediationAttachments(params?: {
  year?: number
  from?: string
  to?: string
}): Promise<BlobResponse> {
  const search = new URLSearchParams()
  if (params?.year) search.set('year', String(params.year))
  if (params?.from) search.set('from', params.from)
  if (params?.to) search.set('to', params.to)

  const qs = search.toString()
  return API_BLOB(
    `/union/mediations/export/attachments${qs ? `?${qs}` : ''}`,
    { method: 'GET' },
    'Fehler beim Herunterladen der Bestell-Anhänge',
    'EXPORT_MEDIATION_ATTACHMENTS_ERROR'
  )
}
